import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import api from '@/lib/api';
import TourCard from '@/components/TourCard';
import { IDS } from '@/constants/testIds';

export default function WeeklyTours() {
  const [tours, setTours] = useState([]);
  useEffect(() => {
    api.get('/tours', { params: { category: 'weekly' } }).then((r) => setTours(r.data)).catch(() => {});
  }, []);

  return (
    <section id="weekly" data-testid={IDS.sectionWeekly} className="py-24 md:py-40 bg-espresso border-t border-border/60">
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 md:mb-20"
        >
          <div>
            <p className="overline mb-4">№ 03 · Weekly Departures</p>
            <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-none">
              Еженедельные <em className="text-saffron">маршруты</em>
            </h2>
          </div>
          <p className="max-w-md text-foreground/70 text-base md:text-lg font-light">
            Стартуем каждую неделю (а короткие туры — ежедневно). Классический Золотой Треугольник, Хавели Мандавы, Ганг и Кхаджурахо.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
          {tours.map((t, i) => (
            <TourCard key={t.slug} tour={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
